var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.917 5A4.083 4.083 0 015 .917h12A4.083 4.083 0 0121.083 5v12A4.083 4.083 0 0117 21.083H5A4.083 4.083 0 01.917 17V5z",
    stroke: "#624DE3",
    strokeWidth: 1.833,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 1.5v19m9.5-9.5h-19",
    stroke: "#624DE3",
    strokeWidth: 1.833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M5.997 4v4m1.416 6.586l-2.828 2.828M7.998 6h-4m14 0h-4m4 9h-4m4 2.5h-4m-6.585-.086l-2.828-2.828",
    stroke: "#624DE3",
    strokeWidth: 1.833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCostCalculator;